import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrequentQuestionsComponent } from './frequent-questions.component';
import { MaterialModule } from 'src/app/material.module';


@NgModule({
  declarations: [FrequentQuestionsComponent],
  imports: [
    CommonModule,
    MaterialModule,
  ]
})
export class FrequentQuestionsModule { }